// Supported UI languages. Kept in sync with backend translate_routes.LANGUAGES.
// speech = BCP-47 tag used for browser text-to-speech voice selection.
export const LANGUAGES = [
  { code: "en", label: "English", native: "English", speech: "en-US" },
  { code: "es", label: "Spanish", native: "Español", speech: "es-ES" },
  { code: "fr", label: "French", native: "Français", speech: "fr-FR" },
  { code: "de", label: "German", native: "Deutsch", speech: "de-DE" },
  { code: "pt", label: "Portuguese", native: "Português", speech: "pt-PT" },
  { code: "it", label: "Italian", native: "Italiano", speech: "it-IT" },
  { code: "nl", label: "Dutch", native: "Nederlands", speech: "nl-NL" },
  { code: "ru", label: "Russian", native: "Русский", speech: "ru-RU" },
  { code: "uk", label: "Ukrainian", native: "Українська", speech: "uk-UA" },
  { code: "pl", label: "Polish", native: "Polski", speech: "pl-PL" },
  { code: "tr", label: "Turkish", native: "Türkçe", speech: "tr-TR" },
  { code: "ar", label: "Arabic", native: "العربية", speech: "ar-SA", rtl: true },
  { code: "fa", label: "Persian", native: "فارسی", speech: "fa-IR", rtl: true },
  { code: "he", label: "Hebrew", native: "עברית", speech: "he-IL", rtl: true },
  { code: "hi", label: "Hindi", native: "हिन्दी", speech: "hi-IN" },
  { code: "bn", label: "Bengali", native: "বাংলা", speech: "bn-IN" },
  { code: "ta", label: "Tamil", native: "தமிழ்", speech: "ta-IN" },
  { code: "te", label: "Telugu", native: "తెలుగు", speech: "te-IN" },
  { code: "ml", label: "Malayalam", native: "മലയാളം", speech: "ml-IN" },
  { code: "kn", label: "Kannada", native: "ಕನ್ನಡ", speech: "kn-IN" },
  { code: "mr", label: "Marathi", native: "मराठी", speech: "mr-IN" },
  { code: "gu", label: "Gujarati", native: "ગુજરાતી", speech: "gu-IN" },
  { code: "pa", label: "Punjabi", native: "ਪੰਜਾਬੀ", speech: "pa-IN" },
  { code: "ur", label: "Urdu", native: "اردو", speech: "ur-PK", rtl: true },
  { code: "ne", label: "Nepali", native: "नेपाली", speech: "ne-NP" },
  { code: "si", label: "Sinhala", native: "සිංහල", speech: "si-LK" },
  { code: "zh", label: "Chinese (Simplified)", native: "简体中文", speech: "zh-CN" },
  { code: "zh-TW", label: "Chinese (Traditional)", native: "繁體中文", speech: "zh-TW" },
  { code: "ja", label: "Japanese", native: "日本語", speech: "ja-JP" },
  { code: "ko", label: "Korean", native: "한국어", speech: "ko-KR" },
  { code: "vi", label: "Vietnamese", native: "Tiếng Việt", speech: "vi-VN" },
  { code: "th", label: "Thai", native: "ไทย", speech: "th-TH" },
  { code: "id", label: "Indonesian", native: "Bahasa Indonesia", speech: "id-ID" },
  { code: "ms", label: "Malay", native: "Bahasa Melayu", speech: "ms-MY" },
  { code: "fil", label: "Filipino", native: "Filipino", speech: "fil-PH" },
  { code: "sw", label: "Swahili", native: "Kiswahili", speech: "sw-KE" },
  { code: "am", label: "Amharic", native: "አማርኛ", speech: "am-ET" },
  { code: "yo", label: "Yoruba", native: "Yorùbá", speech: "yo-NG" },
  { code: "ha", label: "Hausa", native: "Hausa", speech: "ha-NG" },
  { code: "el", label: "Greek", native: "Ελληνικά", speech: "el-GR" },
  { code: "cs", label: "Czech", native: "Čeština", speech: "cs-CZ" },
  { code: "ro", label: "Romanian", native: "Română", speech: "ro-RO" },
  { code: "hu", label: "Hungarian", native: "Magyar", speech: "hu-HU" },
  { code: "sv", label: "Swedish", native: "Svenska", speech: "sv-SE" },
  { code: "da", label: "Danish", native: "Dansk", speech: "da-DK" },
  { code: "fi", label: "Finnish", native: "Suomi", speech: "fi-FI" },
  { code: "no", label: "Norwegian", native: "Norsk", speech: "nb-NO" },
];

export const LANG_BY_CODE = Object.fromEntries(LANGUAGES.map((l) => [l.code, l]));
export const speechLangFor = (code) => (LANG_BY_CODE[code]?.speech) || "en-US";
